import {
  START_GET_STAFF_LIST,
  SUCCESS_GET_STAFF_LIST,
  ERROR_GET_STAFF_LIST,
  START_CREATE_STAFF,
  SUCCESS_CREATE_STAFF,
  ERROR_CREATE_STAFF,
  START_UPDATE_STAFF,
  SUCCESS_UPDATE_STAFF,
  ERROR_UPDATE_STAFF,
  START_DELETE_STAFF,
  SUCCESS_DELETE_STAFF,
  ERROR_DELETE_STAFF,
  RESET_STAFF_STATE,
} from "Actions/StaffAction";

const initialState = {
  staffList: {
    loading: false,
    data: {},
    error: "",
  },
  createStaffData: {
    loading: false,
    data: {},
    error:{},
  },
  updateStaffData: {
    loading: false,
    data: {},
    error: {},
  },
  deleteStaffData: {
    loading: false,
    data: {},
    error: "",
  },
};

export const StaffReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_GET_STAFF_LIST: {
      let oldList = state?.staffList?.data;
      return {
        ...state,
        staffList: {
          loading: action?.payload?.offset > 0 ? false : true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: "",
        },
      };
    }
    case SUCCESS_GET_STAFF_LIST: {
      let oldList = state?.staffList?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        staffList: {
          loading: false,
          data: oldList,
          error: "",
        },
      };
    }
    case ERROR_GET_STAFF_LIST: {
      return {
        ...state,
        staffList: {
          loading: false,
          data: {},
          error: "",
        },
      };
    }
    case START_CREATE_STAFF: {
      return {
        ...state,
        createStaffData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_CREATE_STAFF: {
      let oldData = state?.staffList?.data || {};
      let oldList = Array.isArray(oldData?.list) ? [...oldData.list] : [];
      let newItem = action?.payload?.data;
      let newList = newItem ? [newItem, ...oldList] : oldList;
      return {
        ...state,
        staffList: {
          ...state.staffList,
          data: {
            ...oldData,
            list: newList,
            filterd_record: (oldData?.filterd_record || 0) + (newItem ? 1 : 0),
            total_record: (oldData?.total_record || 0) + (newItem ? 1 : 0),
          },
        },
        createStaffData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_CREATE_STAFF: {
      return {
        ...state,
        createStaffData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_UPDATE_STAFF: {
      return {
        ...state,
        updateStaffData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_UPDATE_STAFF: {
      let oldData = state?.staffList?.data || {};
      let oldList = Array.isArray(oldData?.list) ? [...oldData.list] : [];
      let updatedList = oldList?.map((item) => {
        if (item?.id == action?.id) {
          return {
            ...item,
            ...action?.payload?.data,
          };
        } else {
          return item;
        }
      });
      return {
        ...state,
        staffList: {
          ...state.staffList,
          data: {
            ...oldData,
            list: updatedList,
          },
        },
        updateStaffData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_UPDATE_STAFF: {
      return {
        ...state,
        updateStaffData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_DELETE_STAFF: {
      return {
        ...state,
        deleteStaffData: {
          loading: true,
          data: {},
          error: "",
        },
      };
    }
    case SUCCESS_DELETE_STAFF: {
      let oldData = state?.staffList?.data || {};
      let oldList = Array.isArray(oldData?.list) ? [...oldData.list] : [];
      let filteredList = oldList?.filter((item) => item?.id != action?.id);
      return {
        ...state,
        staffList: {
          ...state.staffList,
          data: {
            ...oldData,
            list: filteredList,
            filterd_record: Math.max(0, (oldData?.filterd_record || 0) - 1),
            total_record: Math.max(0, (oldData?.total_record || 0) - 1),
          },
        },
        deleteStaffData: {
          loading: false,
          data: action.payload,
          error: "",
        },
      };
    }
    case ERROR_DELETE_STAFF: {
      return {
        ...state,
        deleteStaffData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case RESET_STAFF_STATE: {
      return {
        ...state,
        [action.key]: action?.payload || initialState[action.key],
      };
    }
    default: {
      return state || initialState;
    }
  }
};
